import { render, staticRenderFns } from "./BridgeHistoryDetail.vue?vue&type=template&id=43ed63dc&"
import script from "./BridgeHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./BridgeHistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports